import { useState, useEffect, useCallback } from "react";
import axiosConfig from "../../../services/Axios";
import Select from "react-select";
import SelectTheme from "./SelectTheme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { AddressFormContext } from "../../../context/AddressFormContext";
import { useContext } from "react";

const SelectPartnerLogisticAddress = ({
  onChange,
  cancelToken = null,
  emptyOpt = true,
  className,
  isClearable = false,
  isSearchable = false,
  partner,
  value = null,
  setValue = null,
}) => {
  const [options, setOptions] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const { t } = useTranslation();
  const { updateAddressForm } = useContext(AddressFormContext);
  const authUser = useSelector((state) => state.auth);

  const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  };

  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  const fetchAddresses = useCallback(async (token) => {
    let url =
      process.env.REACT_APP_API_URL +
      "/api/partner_logistic_addresses?pagination=false&partner=" +
      partner;

    return await axiosConfig
      .get(url, { cancelToken: token })
      .then((response) => {
        //let addresss = emptyOpt ? [{ label: null, value: null }] : [];
        let addresses = [];

        response.data["hydra:member"].map((address) => {
          addresses.push({
            main: address.main,
            value: address["@id"],
            label:
              address.address + " / " + address.zipcode + " - " + address.city,
          });
        });

        if (value || emptyOpt === false) {
          let selected = value
            ? addresses.filter((o) => o.value === value)[0]
            : addresses.filter((o) => o.main === true)[0];

          setSelectedValue(selected);
        }

        return addresses;
      })
      .then(async (res) => {
        //        if (authUser.user.roles.includes('ROLE_ADMIN')) {
        if (
          authUser.user.roles.includes("ROLE_ADMIN") ||
          authUser.user.switchOriginalUser?.roles.includes("ROLE_ADMIN")
        ) {
          let adminPartner = authUser.user.switchOriginalUser
            ? authUser.user.switchOriginalUser.partner
            : authUser.user.partner;

          if (adminPartner === partner) {
            return res;
          }

          let adminAdresses = await axiosConfig
            .get(
              process.env.REACT_APP_API_URL +
                "/api/partner_logistic_addresses?pagination=false&partner=" +
                adminPartner,
              { cancelToken: token }
            )
            .then((response) => {
              let adds = [];

              response.data["hydra:member"].map((address) => {
                adds.push({
                  main: address.main,
                  value: address["@id"],
                  label:
                    address.address +
                    " / " +
                    address.zipcode +
                    " - " +
                    address.city,
                });
              });

              return adds;
            });

          let groupedOptions = [];

          groupedOptions.push({
            label: "Adresses partenaire",
            options: res,
          });

          groupedOptions.push({
            label: "Mes adresses",
            options: adminAdresses,
          });

          if (value) {
            let selected = null;

            if (res.filter((o) => o.value === value).length !== 0) {
              selected = value
                ? res.filter((o) => o.value === value)[0]
                : res.filter((o) => o.main === true)[0];
            } else if (
              adminAdresses.filter((o) => o.value === value).length !== 0
            ) {
              selected = value
                ? adminAdresses.filter((o) => o.value === value)[0]
                : adminAdresses.filter((o) => o.main === true)[0];
            }
            setSelectedValue(selected);
          }

          return groupedOptions;
        } else {
          return res;
        }
      })
      .catch(function (thrown) {
        if (axiosConfig.isCancel(thrown)) {
          console.log(
            "PartnerLogisticAddress Request canceled : ",
            thrown.message
          );
        }
      });
  }, []);

  useEffect(() => {
    fetchAddresses(cancelToken).then((response) => {
      //console.log(response)
      setOptions(response);
    });
  }, [cancelToken]);

  useEffect(() => {
    if (setValue instanceof Function) {
      setValue(selectedValue?.value);
    }
  }, [selectedValue]);

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span className="text-bioport-orange text-md font-bold">
        {data.label}
      </span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );

  return (
    <>
      <Select
        isSearchable={isSearchable}
        isClearable={isClearable}
        options={options}
        value={selectedValue}
        onChange={(e) => {
          onChange(e && e?.value !== "" ? e.value : null);
          setSelectedValue(e ? e : null);
        }}
        className={`${className} w-full`}
        theme={SelectTheme}
        formatGroupLabel={formatGroupLabel}
      />

      {partner && (
        <div className="text-xs pt-2 flex items-center">
          <FontAwesomeIcon
            icon={faPlusCircle}
            size="lg"
            className="mr-2 text-bioport-orange"
          />
          <div
            onClick={() =>
              updateAddressForm({
                modalOpen: true,
                partner: {
                  ...partner,
                  "@id": partner,
                  partnerLogisticAddresses: options,
                },
                cb: function (data) {
                  const opts = options.concat({
                    main: data.main,
                    value: data["@id"],
                    label:
                      data.address + " / " + data.zipcode + " - " + data.city,
                  });

                  setOptions(opts);
                  setSelectedValue(
                    opts.filter((o) => o.value === data["@id"])[0]
                  );

                  if (onChange instanceof Function) {
                    onChange(data["@id"]);
                  }
                },
              })
            }
            className="hover:underline cursor-pointer"
          >
            {t("partnerLogisticAddress.create")}
          </div>
        </div>
      )}
    </>
  );
};

export default SelectPartnerLogisticAddress;
